<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import { onMount } from 'svelte';
    import { _completeExamData, _userObj } from "./store.js";
    import MultipleChoiceQuestion from "./multipleChoiceQuestion.svelte";
    import MultipleResponseQuestion from "./multipleChoiceResponse.svelte";
    import NumericalQuestion from "./numerical.svelte";

    export let currentQuestionNo;
    export let currentSectionNo;
    export let token;

    export let doneTestId;
    export let rank

    let statId;

    let userObj = {
        name: "",
        mobileNo: ""
    };

    let show = false;

    let language = "English";

    let currentQuestion = {};

    let userResponses = {}

    let questionBank = {};

    let completeExamData = {};

    let maxMarks = 0;

    let visible = true;

    let remainingTime = 0;

    let doneTestObj = {}

    $: currentQuestion = questionBank[completeExamData.sections && completeExamData.sections[currentSectionNo - 1].questions[currentQuestionNo - 1]];

    $: language = currentQuestion?.data?.question[language] ? language : "English";

    async function api_getReviewData(doneTestId) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var payload = JSON.stringify({
                doneTestId: doneTestId,
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: payload,
            };
            try {
                var resObj = await fetch(  '/testAPI/getReviewData', requestOptions);
                var response = await resObj.json();
                return response;
            } catch (error) {
                console.error("error", error);
                return { error: error };
            }
        }

    const ansChanged = function (data) {
        if (!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].answer = data.ans;
    }

    const toggleMarked = function (data) {
        if (!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].marked = !userResponses[data.qId].marked;
    }

    const questionVisited = function (data) {
        if (!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].visited = true;
    }

    const expand = (sectionTitle) => {
        if (completeExamData.sections) {
            for (let i = 0; i < completeExamData.sections.length; i++) {
                if (completeExamData.sections[i].title == sectionTitle) {
                    completeExamData.sections[i].active = !completeExamData.sections[i].active;
                }
            }
        }
    }

    const onBackBtnClick = () => {

        if (currentSectionNo == 1 && currentQuestionNo == 1) {

        } else {
            if (currentSectionNo != 1 && currentQuestionNo == 1) {
                

                toQuestion(completeExamData.sections[Number(currentSectionNo) - 2].questions.length, (Number(currentSectionNo) - 1))
            } else {
                toQuestion((Number(currentQuestionNo) - 1), (currentSectionNo))
            }
        }
    }

    const onNextBtnClick = () => {
        if (currentSectionNo == completeExamData.sections.length && currentQuestionNo == completeExamData.sections[currentSectionNo - 1].questions.length) {
        } else {
            if (currentQuestionNo >= completeExamData.sections[currentSectionNo - 1].questions.length) {
                toQuestion(1, (Number(currentSectionNo) + 1))
            } else {
                toQuestion((Number(currentQuestionNo) + 1), (currentSectionNo))
            }
        }
    }

    const toQuestion = (qIndex, sIndex) => {
        navigate("/review/" + doneTestId + "/" + rank + "/" +  (qIndex) + "/" + (sIndex));
    }

    _userObj.subscribe(value => { userObj = value });

    _completeExamData.subscribe(value => {
        maxMarks = 0;
        if (value && value.qTextObj) {
            for (let i = 0; i < value.qTextObj.length; i++) {
                maxMarks += value.qTextObj[i].additionalInfo.pmarks;
            }
        }
        if (value && value.sections) {
            for (let i = 0; i < value.sections.length; i++) {
                value.sections[i].active = true;
            }
        }
        if (value && value.qTextObj) {
            for (let i = 0; i < value.qTextObj.length; i++) {
                questionBank[value.qTextObj[i]._id] = value.qTextObj[i];
            }
        }
        completeExamData = value
    });

    onMount(async () => {
        window.isExamEnded = true;
        let tokenRes = await api_getReviewData(doneTestId);
        if(tokenRes){
            userObj = tokenRes.doneTest.userObj;
        }
        _userObj.set(userObj);
        _completeExamData.set(JSON.parse(tokenRes.doneTest.completeTestData.testData.testData));

        let startedAt = new Date(tokenRes.doneTest.startedAt);
        let endedOn = new Date(tokenRes.doneTest.endedOn);
        remainingTime = (endedOn - startedAt) / 1000;

        doneTestObj = tokenRes.doneTest;


        for (let i = 0; i < tokenRes.doneTest.testStats.length; i++) {
            let aTestStat = tokenRes.doneTest.testStats[i];
            for (let j = 0; j < completeExamData.qTextObj.length; j++) {
                const aQ = completeExamData.qTextObj[j];
                if(aQ._id == aTestStat.questionId){

                    if(aQ.qType == "multipleResponse"){
                        let isCorrect = true;
                        if(aTestStat.answer && aTestStat.answer.length == aQ.data.answer.length){
                            for (let o = 0; o < aTestStat.answer.length; o++) {
                                const aAns = aTestStat.answer[o];
                                if(aQ.data.answer.indexOf(aAns) == -1){
                                    isCorrect = false;
                                    break;
                                }
                                
                            }
                        }else{
                            isCorrect = false;
                        }
                        userResponses[aTestStat.questionId] = {
                            marks : aTestStat.marks,
                            correct : isCorrect,
                            answer: aTestStat.answer,
                            marked: aTestStat.marked,
                            timer: Number(aTestStat.timer),
                            visited: aTestStat.visited,
                        };
                    }else{
                        userResponses[aTestStat.questionId] = {
                            marks : aTestStat.marks,
                            correct : aTestStat.answer && aTestStat.answer.toLowerCase() == aQ.data.answer.toLowerCase(),
                            answer: aTestStat.answer,
                            marked: aTestStat.marked,
                            timer: Number(aTestStat.timer),
                            visited: aTestStat.visited,
                        };
                    }

                    
                    break;
                }
            }
        }
    });
</script>
<div class="container">
    <main>
        <div class="q-header">
            <div class="win-action" on:click={()=>window.history.back()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-arrow-left">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
            </div>
            <div class="exam-info">
                {completeExamData.name || ""}
            </div>
            <div class="timer">
                <div class="timer-value">
                    <div class="h-timer">
                        <div class="h-timer-count">
                            {Math.floor(remainingTime / 3600)}
                        </div>
                        <div class="timer-txt">
                            hh
                        </div>
                    </div>
                    <div class="timer-seperator">
                        :
                    </div>
                    <div class="m-timer">
                        <div class="m-timer-count">
                            {Math.floor(remainingTime % 3600 / 60)}
                        </div>
                        <div class="timer-txt">
                            mm
                        </div>
                    </div>
                    <div class="timer-seperator">
                        :
                    </div>
                    <div class="s-timer">
                        <div class="s-timer-count">
                            {Math.floor(remainingTime % 3600 % 60)}
                        </div>
                        <div class="timer-txt">
                            ss
                        </div>
                    </div>
                </div>
                <div class="time-left-txt">
                    Duration
                </div>
            </div>
            <div class="open-aside" on:click={()=>show=!show}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-menu">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </div>
        </div>
        <div class="marks-section">
            <div class="marks-text">
                Marks : {doneTestObj.total ? doneTestObj.total.totalMarks : 0}/{doneTestObj.total ? doneTestObj.total.maximumMarks : 0}
            </div>
            <div class="marks-other">
                +{doneTestObj.total ? doneTestObj.total.totalPMarks : 0} / -{doneTestObj.total ? doneTestObj.total.totalNMarks : 0}
            </div>
            <div class="mark-txt-end">
                Rank : {rank}
            </div>
        </div>
        {#if completeExamData.sections && completeExamData.sections.length != 1 && completeExamData.sections[0].title !=
        "All Questions"}
        <div class="q-sections">
            {#each completeExamData.sections as aSection, index}
            <div class="a-sec" class:active={index==(currentSectionNo-1)} on:click={()=>{toQuestion(1,(index+1))}}
                >
                {aSection.title}({aSection.questions.length})

            </div>
            {/each}
        </div>
        {/if}
        <div class="q-info">
            <div class="q-number">
                Question No : {currentQuestionNo}
            </div>
            <div class="q-time">
                00:{(userResponses[currentQuestion?._id] && userResponses[currentQuestion?._id].timer) ?
                userResponses[currentQuestion?._id].timer : 0}
            </div>
            <div class="q-marks">
                Marks : {(userResponses[currentQuestion?._id] && userResponses[currentQuestion?._id].marks) ?
                (userResponses[currentQuestion?._id].marks > 0 ? ("+"+userResponses[currentQuestion?._id].marks) : userResponses[currentQuestion?._id].marks) : 0}
            </div>
            <div class="q-lang">
                <select name="" id="" bind:value={language}>
                    {#if currentQuestion && currentQuestion.data}
                    {#each Object.entries(currentQuestion?.data?.question) as [langName, langValue]}
                    <option value="{langName}">{langName}</option>
                    {/each}
                    {/if}
                </select>
            </div>
        </div>
        <div class="q-content">
            {#if currentQuestion?.data?.isEssayAttached && currentQuestion?.data?.isEssayAttached[0] == "true"}
            <div class="q-essay">
                <div class="q-label">
                    Essay :
                </div>
                <div class="q-essay-data">
                    {@html (currentQuestion?.data?.attachEssay[language]?.content || "")}
                </div>
            </div>
            {/if}
            <div class="q-data">
                <div class="q-question">
                    <div class="q-label">
                        Question :
                    </div>
                    <div class="q-content-body">
                        {@html currentQuestion?.data?.question[language]}
                    </div>
                </div>
                {#if currentQuestion}
                {#key currentQuestion?._id}

                    {#if currentQuestion?.qType == "multipleChoice"}
                        <MultipleChoiceQuestion 
                            mode="review" 
                            currentQuestion={currentQuestion} 
                            ansChanged={ansChanged} 
                            language={language}
                            questionVisited={questionVisited} 
                            thisQUserResponses={userResponses[currentQuestion?._id] ?
                            userResponses[currentQuestion?._id] : {}} 
                        />

                    {:else if currentQuestion?.qType == "multipleResponse"}
                        <MultipleResponseQuestion 
                            mode="review" 
                            currentQuestion={currentQuestion} 
                            ansChanged={ansChanged} 
                            language={language}
                            questionVisited={questionVisited} 
                            thisQUserResponses={userResponses[currentQuestion?._id] ?
                            userResponses[currentQuestion?._id] : {}} 
                        />
                    {:else if currentQuestion?.qType == "numerical"}
                    <NumericalQuestion mode="review" currentQuestion={currentQuestion} ansChanged={ansChanged} language={language}
                        questionVisited={questionVisited} thisQUserResponses={userResponses[currentQuestion?._id] ?
                        userResponses[currentQuestion?._id] : {answer:''}} />
                    {:else}
                    -
                    {/if}
                {/key}
                {/if}
                <div class="q-explanation">
                    <div class="q-label">
                        Explanation :
                    </div>
                    <div>
                        {@html currentQuestion?.data?.explanation[language]}
                    </div>
                </div>
            </div>
        </div>
        <div class="q-footer">
            <button class="bottom-btn" on:click={onBackBtnClick}>
               
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-left">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                Prev
            </button>
            <div class="f1"></div>
            <button class="bottom-btn" on:click={onNextBtnClick}>
                {#if completeExamData.sections && currentSectionNo == completeExamData.sections.length &&
                currentQuestionNo == completeExamData.sections[currentSectionNo
                - 1].questions.length}
                Next
                {:else}
                Next
                {/if}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevron-right">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>
    </main>
    <nav class="menu" tabindex="0" class:show={show}>
        <!-- <div class="smartphone-menu-trigger"></div> -->
        <!-- <div class="smartphone-menu-trigger-close"></div> -->
        <div class="avater">
            <div class="avatar-img">
                <img src="/images/user.jpg" style="border-radius: 50%; height: 42px;" alt="">
            </div>
            <div class="user-info">
                <div class="user-name">
                    {userObj && userObj.name ? userObj.name : ""}
                </div>
                <div class="user-email-phno">
                    {userObj && userObj.mobileNo ? userObj.mobileNo : ""}
                </div>
            </div>
            <div class="close-aside" on:click={()=>show=!show}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-x">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </div>
        </div>
        <div class="side-section-options">
            <div class="grid-view active">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-grid">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="14" y="14" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
            </div>
            <div class="list-view ">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-list">
                    <line x1="8" y1="6" x2="21" y2="6"></line>
                    <line x1="8" y1="12" x2="21" y2="12"></line>
                    <line x1="8" y1="18" x2="21" y2="18"></line>
                    <line x1="3" y1="6" x2="3.01" y2="6"></line>
                    <line x1="3" y1="12" x2="3.01" y2="12"></line>
                    <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
            </div>
        </div>
        <div class="side-sections">
            {#if completeExamData.sections}
            {#each completeExamData.sections as section, sIndex}
            <div class="accordion">
                <div class="sec-header" on:click={()=> expand(section.title) }>
                    {section.title}
                </div>
                {#if section.active}
                <div class="slider fadeIn">
                    {#each section.questions as item, qIndex (item)}
                    <div class="q-btn" 
                        class:current={currentQuestionNo==qIndex+1 && currentSectionNo==sIndex+1}
                        class:marked-bubble={userResponses[item]?.marked} 
                        class:answered={ userResponses[item]?.correct} 
                        class:not-answered={ !userResponses[item]?.correct && userResponses[item]?.answer?.length} 
                        class:visited-no-ans={ userResponses[item]?.visited && !userResponses[item]?.answer?.length}
                        on:click={()=>toQuestion((qIndex+1),(sIndex+1) )}
                        >
                        <div class="q-list-no">{qIndex+1}</div>
                    </div>
                    {/each}
                </div>
                {/if}
            </div>
            {/each}
            {/if}
        </div>
        <div class="legends">
            <table>
                <tr>
                    <td>
                        <div>
                            <div class="q-btn answered leg">
                                <div class="q-list-no"> </div>
                            </div>
                            Correct ({doneTestObj.total ? doneTestObj.total.totalCorrectAns : 0})
                        </div>
                    </td>
                    <td>
                        <div>
                            <div class="q-btn marked leg">
                                <div class="q-list-no"> </div>
                            </div>
                            Marked
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <div class="q-btn not-answered leg">
                                <div class="q-list-no"> </div>
                            </div>
                            Wrong ({doneTestObj.total ? doneTestObj.total.totalWrongAns : 0})
                        </div>
                    </td>
                    <td>
                        <div>
                            <div class="q-btn leg visited-no-ans">
                                <div class="q-list-no"> </div>
                            </div>
                            Visited
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="submit" on:click={()=>navigate("/reattempt/"+doneTestId+"/1/1")}>
            Re-attempt Test
        </div>
    </nav>
</div>

